<template lang="pug">
    header
        button.hamburger.hamburger--3dy(type="button" :class="{ 'is-active': sidebar }" @click="toggleSidebar")
            span.hamburger-box
                span.hamburger-inner
        .container.is-hidden-touch
            .columns
                .logo-wrapper
                    img#logo.is-pulled-left(v-if="logo && logo.id" v-lazy="image" title="logo" rel="noopener")
                    img#logo.is-pulled-left(v-else src="@/assets/logo.svg")
                .main-menu-wrapper.column
                    nav#main-menu.is-pulled-right
                        tree-menu(:items="items" :max-depth="2" :delay="400")
</template>

<script>

import _ from 'lodash'
import { mapGetters, mapMutations } from 'vuex'

import NestedSet from '@/nested-set-lib'

export default {
    name: 'Header',
    computed: {
        items() {
            const menu = this.menus.find(menu => menu.key === 'main-menu')
            let items = _.get(menu, 'menuItems') || []
            items = _.cloneDeep(items)

            if (items.length) {
                return NestedSet.createTree(items)
            }

            return items
        },
        image() {
            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            const fit = 'fit=fill&w=350&h=150'

            let width = this.logo.width
            let height = this.logo.height

            return {
                src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
                error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
                width,
                height,
            }
        },
        ...mapGetters({
            logo: 'logo',
            menus: 'menus',
            sidebar: 'sidebar',
        })
    },
    methods: {
        toggleSidebar() {
            this.updateSidebarVisibility(! this.sidebar)
        },
        ...mapMutations({
            updateSidebarVisibility: 'updateSidebarVisibility',
        })
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';

    header
        margin-top: 15px
        position: sticky
        width: 100%
        z-index: 999
        top: 0
        background-color: #fff
        #logo
            height: 100px
        .hamburger
            height: 55px
            outline: none
            +desktop
                display: none

        .container
            margin-top: 1rem
            height: 84px
            .columns
                height: 100%
                .logo-wrapper
                    display: flex
                    justify-content: center
                    flex-direction: column
                    position: absolute
                    height: 80%
                    left: 0
                    top: 0
                .main-menu-wrapper.column
                    display: flex
                    justify-content: flex-end

        .main-menu-wrapper
            margin-top: 20px
            padding-bottom: 0
            .navbar-item
                // color: #222222 !important

            #main-menu
                z-index: 10
                & /deep/
                    ul
                        &.tree-menu
                            & > li
                                position: relative
                                transition: background-color .3s ease
                                & > .tree-item a
                                    text-decoration: none
                                    font-weight: 800
                                    text-transform: uppercase
                                    color: #222222
                                    padding: 15px
                                    display: inline-block
                                    transition: color .3s ease
                                &.hover
                                    background-color: $primary
                                    & > .tree-item a
                                        color: #fff
                                li
                                    // padding: 0 9px
                                    width: 100%
                                    background-color: $primary
                                    & > .tree-item a
                                        font-weight: bold
                                        color: #fff
                                        display: block
                                        max-width: 300px
                                        overflow: hidden
                                        text-overflow: ellipsis
                                        white-space: nowrap
                                        &:before
                                            font-family: 'Font Awesome 5 Free' !important
                                            speak: none
                                            font-weight: 900
                                            content: '\f054'
                                            color: #fff
                                            padding-right: 6px
                                    &.hover
                                        background-color: #fff
                                        & > .tree-item a
                                            color: #222222
                                            &:before
                                                color: #222222
                    & > ul
                        &.tree-menu
                            & > li
                                // padding: 0 9px 33px 9px
                                display: inline-block
                                & > .tree-item a
                                    padding: 15px 15px 8px 15px
                                    border-bottom: 5px solid transparent
                                    &.router-link-exact-active
                                        color: $primary
                                        border-bottom: 5px solid $primary
                                &.hover > .tree-item a.router-link-exact-active
                                    color: #fff
                                & > ul
                                    &.tree-menu
                                        position: absolute
                                        left: 0
                                        top: 100%
                                        display: flex
                                        flex-direction: column
                                        min-width: 100%
                                        box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3)
                            ul ul
                                min-width: 200px
                                margin-bottom: 9px
                                position: absolute
                                right: 100%
                                top: 0
                                // box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3)
                                li > .tree-item a
                                    // padding: 10px 15px
                                    // font-size: .8rem
                                    // &:before
                                    //     font-size: 0.5rem
                                    //     position: relative
                                    //     top: -1px

                    .show-enter-active, .show-leave-active
                        transition: opacity 0.3s ease, transform 0.3s ease
                        transform-origin: left center
                    .show-enter, .show-leave-to
                        opacity: 0
                        transform: translateY(6px)
</style>
